export const AZURE_FOUNDRY_PROVIDER_PREFIX = "azure";
export const KIMI_K26_AZURE_MODEL_ID = "kimi-k2.6";
export const KIMI_K26_AZURE_MODEL_REF = `${AZURE_FOUNDRY_PROVIDER_PREFIX}/${KIMI_K26_AZURE_MODEL_ID}`;
export const DEEPSEEK_V4_PRO_AZURE_MODEL_ID = "deepseek-v4-pro";
export const DEEPSEEK_V4_PRO_AZURE_MODEL_REF = `${AZURE_FOUNDRY_PROVIDER_PREFIX}/${DEEPSEEK_V4_PRO_AZURE_MODEL_ID}`;
